import React from 'react';
import PropTypes from 'prop-types';
import FourEyesPopup from '../popups/FourEyesPopup';
import ConfirmPopup from '../popups/ConfirmPopup';
import { extendedMutationType } from '../../types';
import { joinClassNames } from '../../utils';

BackendHandlingButton.propTypes = {
    children: PropTypes.node.isRequired,
    onConfirm: PropTypes.func.isRequired,
    extendedMutation: extendedMutationType.isRequired,
    message: PropTypes.string.isRequired,
    extraConfirmationMessage: PropTypes.string.isRequired,
    className: PropTypes.string,
    onCancel: PropTypes.func,
    disabled: PropTypes.bool,
};

BackendHandlingButton.defaultProps = {
    className: '',
    onCancel: null,
    disabled: false,
};

function BackendHandlingButton(props) {
    const {
        children,
        onConfirm,
        className,
        extendedMutation,
        message,
        extraConfirmationMessage,
        onCancel,
        disabled,
    } = props;
    const onCancelHandler = () => onCancel && onCancel();
    return (
        <>
            <button type="submit" className={joinClassNames('backend-handling-button', className)} onClick={() => onConfirm()} disabled={disabled}>{children}</button>
            {extendedMutation.isFourEyesNeeded && (
                <FourEyesPopup
                    onConfirm={(userId, userPassword) => onConfirm({ ...extendedMutation.extraVariables, fourEyesUserId: userId, fourEyesPassword: userPassword })}
                    onCancel={onCancelHandler}
                    message={message}
                    extendedMutation={extendedMutation}
                />
            )}
            {extendedMutation.isExtraConfirmationNeeded && <ConfirmPopup onConfirm={() => onConfirm({ ...extendedMutation.extraVariables, extraConfirmation: true })} onCancel={onCancelHandler} message={extraConfirmationMessage} />}
        </>
    );
}

export default BackendHandlingButton;
